import { trackMetric } from './Telemetry.js'

/**
 * Evaluation-project telemetry. Projects have no lab/customer split (that's an order concept), so
 * these carry only the automatic org bundle plus project context. Project participant role
 * (owner vs invited) can be added as an attribute later if we surface it.
 *
 * Everything here used to be emitted from the slice only — i.e. we recorded that projects were
 * *mutated* and never that they were *looked at*. `opened` sat in this union with no call site,
 * so a project that was created once and then used daily was indistinguishable from one that was
 * created and abandoned. Reach comes from `opened` plus the project-scoped `viz.opened` events.
 */
export type ProjectAction =
  | 'created'
  /** The project detail page was mounted. `reason` separates a first visit from a revisit. */
  | 'opened'
  | 'sample_added'
  | 'sample_removed'
  /** Draft mode switched off — the project now auto-refreshes on sample changes. */
  | 'activated'
  /** Draft mode switched on — samples are batched without a refresh between them. */
  | 'draft_enabled'
  /** The merged cross-order XLSX was generated and handed over. */
  | 'report_downloaded'
  /** Project settings changed (name, taxonomy, red-list mode, …). */
  | 'edited'
  | 'invite_sent'
  | 'invite_accepted'
  | 'participant_removed'
  | 'permission_changed'
  /** The beta metadata grid was opened on the project's own samples. */
  | 'edit_data_beta'

export const trackProjectAction = (action: ProjectAction, projectId: string, extra: Record<string, string | number | boolean> = {}): void => {
  trackMetric('project.action', { action, project_id: projectId, ...extra })
}
